import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Crown, Lightning } from '@phosphor-icons/react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useSubscription() {
  const [isPro, setIsPro] = useState(null); // null = loading
  const [subscription, setSubscription] = useState(null);

  const checkSubscription = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/user/subscription`);
      setIsPro(data.is_pro || false);
      setSubscription(data);
    } catch {
      setIsPro(false);
    }
  }, []);

  useEffect(() => { checkSubscription(); }, [checkSubscription]);

  return { isPro, subscription, refresh: checkSubscription };
}

export function ProGate({ feature, children }) {
  const { isPro } = useSubscription();

  if (isPro === null) {
    return (
      <div className="flex items-center justify-center min-h-[40vh]">
        <div className="w-8 h-8 border-2 border-[#FF3B30] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!isPro) {
    return (
      <div className="tactical-card p-8 text-center max-w-lg mx-auto mt-8" data-testid="pro-gate">
        <Crown weight="fill" className="w-14 h-14 text-[#FF3B30] mx-auto mb-4" />
        <h2 className="text-3xl font-black tracking-tighter mb-2">PRO FEATURE</h2>
        <p className="text-[#A1A1AA] mb-6">
          {feature} is a Pro feature. Upgrade to unlock AI-powered plans, smart nutrition, custom workouts, and more.
        </p>
        <Link to="/pricing" className="btn-primary px-8 py-3 text-lg inline-flex items-center gap-2" data-testid="upgrade-button">
          <Lightning weight="bold" className="w-5 h-5" /> Upgrade to Pro
        </Link>
        <p className="text-xs text-[#71717A] mt-3">Starting at $4.99/month</p>
      </div>
    );
  }

  return children;
}
